/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Navigation, SVGIcon } from "@nordcloud/gnui";
import { RouteParams } from "~/models";
import { ROUTES } from "~/routing";

export enum TabsPath {
  INFO = "info",
  SERVICES = "services",
  PRODUCTS = "products",
  CONTRACTS = "contracts",
  TEAM = "team",
  APP = "applications",
  ASSIGNMENT_RULES = "assignment-rules",
  BILLING_RULES = "billing-rules",
  CONTACT = "contacts",
  COMMENTS = "comments",
  TOOLS = "tools",
}

function CustomerNavigation() {
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const location = useLocation();
  const isActive = (check: string) =>
    location.pathname === check || location.pathname === `${check}/`;

  const params = (to: string) => ({
    as: Link,
    to,
    className: `hasBg ${isActive(to) && "active"}`,
  });

  const MENU_ITEMS = [
    {
      label: "Basic information",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.INFO}`,
    },
    {
      label: "Services",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.SERVICES}`,
    },
    {
      label: "Products",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.PRODUCTS}`,
    },
    {
      label: "Contracts",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.CONTRACTS}`,
    },
    {
      label: "NC Team Information",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.TEAM}`,
    },
    {
      label: "Applications & Environments",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.APP}`,
    },
    {
      label: "Assignment Rules",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.ASSIGNMENT_RULES}`,
    },
    {
      label: "Billing Rules",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.BILLING_RULES}`,
    },
    {
      label: "Customer Contacts",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.CONTACT}`,
    },
    {
      label: "Comments",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.COMMENTS}`,
    },
    {
      label: "Tools and Integrations",
      link: `${ROUTES.customers.index}/${customerId}/${TabsPath.TOOLS}`,
    },
  ];

  return (
    <Navigation.Container secondary>
      {MENU_ITEMS?.map((item) => (
        <Navigation.Item key={item.link} {...params(item.link)}>
          {item.label} <SVGIcon name="arrowRight" />
        </Navigation.Item>
      ))}
    </Navigation.Container>
  );
}

export default CustomerNavigation;
